// File: src/components/CalendarView/index.js
import React, { useState } from 'react';
import { Plus, Calendar as CalendarIcon } from 'lucide-react';
import { Container } from '../ui/Container';
import { GradientButton } from '../ui/GradientButton';
import AppointmentModal from './AppointmentModal';
import DetailedCalendarView from './DetailedCalendarView';
import api from '../../api';
import { useGoogleCalendar } from '../../hooks/useGoogleCalendar';

const CalendarView = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const { error, authorizeCalendar } = useGoogleCalendar();

  const handleNewAppointment = () => {
    setSelectedAppointment(null);
    setIsModalOpen(true);
  };

  const handleSaveAppointment = async (appointmentData) => {
    try {
      await api.post('/appointments', {
        ...appointmentData,
        date: selectedDate
      });
      setIsModalOpen(false);
      // Refresh appointments
    } catch (error) {
      console.error('Error saving appointment:', error);
    }
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  // If no calendar access, show connect button
  if (error === 'Google Calendar access not granted') {
    return (
      <Container>
        <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4">
          <CalendarIcon className="w-16 h-16 text-gray-400" />
          <h2 className="text-xl font-semibold text-gray-700">
            Connect to Google Calendar
          </h2>
          <p className="text-gray-500 text-center max-w-md">
            To view and manage your appointments, please connect your Google Calendar account.
          </p>
          <GradientButton onClick={authorizeCalendar}>
            Connect Google Calendar
          </GradientButton>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Appointments Calendar</h1>
        <GradientButton onClick={handleNewAppointment}>
          <Plus className="w-4 h-4 mr-2" />
          New Appointment
        </GradientButton>
      </div>

      <DetailedCalendarView onDateSelect={handleDateSelect} />

      <AppointmentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        appointment={selectedAppointment}
        onSave={handleSaveAppointment}
        selectedDate={selectedDate}
      />
    </Container>
  );
};

export default CalendarView;
